/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var id          = 'pAdvertising',
    Page        = require('stb-component-page'),
    page        = new Page({$node: document.getElementById(id), focusable: false}),
    Button      = require('stb-component-button'),
    keys        = require('stb-keys'),
    player      = require('../modules/advertising/player'),
    advertising = require('../modules/advertising/core'),
    skipButton  = new Button({
        $node: document.getElementById('skipButton'),
        value: gettext('Skip ad'),
        events: {
            hide: function () {
                this.blur();
                this.events.click = [];
            }
        }
    }),
    $buttonIcon = document.createElement('div');


$buttonIcon.className = 'theme-icon theme-icon-next';
skipButton.$node.appendChild($buttonIcon);
page.add(skipButton);


page.addListener('show', function ( event ) {
    console.log(event, 'advertising page show event');
    skipButton.hide();
});


page.addListener('keydown', function ( event ) {
    if ( event.code === keys.exit ) {
        player.stop();
        skipButton.hide();
    } else if ( event.code === keys.set || event.code === keys.app ) {
        player.stop();
        skipButton.hide();
        core.call('blur');
        core.call('hide');
    }
});


advertising.addListener('button:show', function ( data ) {
    skipButton.once('click', function () {
        advertising.emit('skip', {target: data.target, done: data.done});
        skipButton.hide();
    });
    skipButton.show();
    skipButton.focus();
});

advertising.addListener('button:hide', function () {
    skipButton.hide();
});


// public
module.exports = page;
